import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-website-related-content-url',
  templateUrl: './website-related-content-url.component.html',
})
export class WebsiteRelatedContentUrlComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  constructor() {}

  ngOnInit() {}
}
